export const APP_NAME = 'learning-center';
export const SCREENS = {
  HOME: 'home-page',
  HUBLESS: 'hubless-error-message',
  LESSON: 'lesson',
  LESSONS: 'lessons-dashboard',
  MY_LEARNING: 'my-learning',
  WATCH_LATER: 'watch-later',
  MY_PLAYLISTS: 'my-playlists',
  MY_TEAM: 'my-team',
  TRACK: 'track',
  TRACKS: 'tracks-dashboard',
  PARTNER: 'partner-tracks-dashboard',
  PLAYLIST: 'playlist',
  WIZARD: 'wizard',
  AUTHENTICATED_COURSE_BROCHURE: 'authenticated-course-brochure',
  SHORT: 'short-form',
  ACADEMY_LABS: 'academy-labs',
  ACADEMY_ONBOARDING: 'academy-onboarding',
  ACADEMY_ASSISTANT: 'academy-assistant'
};
export const SUB_SCREENS = {
  EXAM: 'exam',
  CONCLUSION: 'conclusion',
  RECOMMENDATIONS: 'recommendations',
  GET_STARTED_SEARCH_PROMPT: 'get-started-search-prompt'
};